import { legacyRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// The old `journeys` URL for the CDP destination card, which the integrations directory still links
// to. The redirect into Pipelines lives at `/workspaces/:workspaceId/integrations/cdp_in`.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_in')({
  beforeLoad: legacyRedirect('/workspaces/:workspaceId/integrations/cdp_in'),
});
